<template>
  <v-card
    outlined
    class="d-flex flex-column full_height dashboard-box"
    :max-width="maxWidth"
    :data-cy="dataCyDashboardBoxButton"
    @click="clickButton"
  >
    <slot name="prepend" />
    <v-card-text class="pa-0" :data-cy="dataCyDashboardBox">
      <div class="d-flex justify-space-between" :class="{ 'flex-column': iconPosition === 'left' }">
        <div v-if="iconPosition === 'left'" class="text-left mb-4">
          <v-img max-width="48" max-height="48" contain :src="$asset(`img/icons/${icon}.svg`)" />
        </div>
        <div>
          <div class="text-h2 mb-2 text-left">
            {{ title }}
          </div>
          <div class="text-body-small grey-darken-1--text text-left">{{ text }}</div>
        </div>
        <div v-if="iconPosition === 'right'">
          <v-img eager width="48" height="48" :src="$asset(`img/icons/${icon}.svg`)" contain />
        </div>
      </div>
    </v-card-text>
    <v-spacer />
  </v-card>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'DashboardBox',
  props: {
    dialogName: {
      type: String,
      required: false
    },
    dialogType: {
      type: String,
      default: 'profileDialog',
      validator(value) {
        return ['profileDialog', 'dynamicForm'].includes(value);
      }
    },
    icon: {
      type: String,
      required: true
    },
    iconPosition: {
      type: String,
      default: 'right',
      validator(value) {
        return ['left', 'right'].includes(value);
      }
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    maxWidth: {
      type: [String, Number],
      required: false
    },
    dataCyDashboardBoxButton: {
      type: String,
      required: false
    },
    dataCyDashboardBox: {
      type: String,
      required: false
    }
  },
  methods: {
    ...mapMutations({
      setDialog: 'profile/dashboard/setDialog'
    }),
    clickButton() {
      if (this.dialogName) {
        if (this.dialogType === 'dynamicForm') {
          this.updateFormDialogs({
            formName: this.dialogName,
            value: true
          });
        } else {
          this.setDialog(this.dialogName);
        }
      }
      this.$emit('clickButton');
    }
  }
};
</script>
